import { alpha, SxProps, Theme } from '@mui/material/styles';

/**
 * Option groups (period basis, scope, deliver-as): a bordered strip whose selected option
 * is tinted with the primary colour, so the choice reads at a glance.
 */
export const optionToggleSx: SxProps<Theme> = {
  '& .MuiToggleButton-root': {
    textTransform: 'none',
    fontWeight: 500,
    px: 1.75,
    color: 'text.secondary',
    borderColor: 'divider',
    '&:hover': { backgroundColor: (t) => alpha(t.palette.primary.main, 0.04) },
    '&.Mui-selected': {
      fontWeight: 700,
      color: 'primary.dark',
      backgroundColor: (t) => alpha(t.palette.primary.main, 0.1),
      '&:hover': { backgroundColor: (t) => alpha(t.palette.primary.main, 0.14) },
    },
  },
};

/**
 * Top-level mode switch: a grey track with the selected option raised on a white pill.
 */
export const segmentedToggleSx: SxProps<Theme> = {
  p: 0.5,
  gap: 0.5,
  borderRadius: 2,
  backgroundColor: 'action.hover',
  '& .MuiToggleButtonGroup-grouped': {
    border: 0,
    borderRadius: '8px !important',
    m: 0,
  },
  '& .MuiToggleButton-root': {
    textTransform: 'none',
    fontWeight: 600,
    px: 2,
    color: 'text.secondary',
    '&.Mui-selected': {
      color: 'text.primary',
      backgroundColor: 'background.paper',
      boxShadow: '0 1px 2px rgba(16, 24, 40, 0.12)',
      '&:hover': { backgroundColor: 'background.paper' },
    },
  },
};
